import axios from './instance'

const configToken = (token) => {
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
}

export const getAllReservationAttachmentTypes = async (token) => {
  try {
    const res = await axios.get('/api/reservation-attachments-types', configToken(token))
    return res
  } catch (err) {
    throw err.response
  }
}
